export default __webpack_public_path__ + "static/media/folder-blue.6014cf24.svg";